const factorDetails = [
  {
    title: "فروشنده",
    value: "sellerInfo",
  },
  {
    title: "خریدار",
    value: "customerInfo",
  },
  {
    title: "فاکتور",
    value: "invoiceInfo",
  },
  {
    title: "لوگو",
    value: "logo",
  },
];

export default factorDetails;
